import jwtDecode from "jwt-decode";

// Browser-safe stand-in for jsonwebtoken's `decode`. The client only ever reads
// claims out of a token — signing and verification stay on the server — so
// pulling in jsonwebtoken (and with it Node's crypto/stream/util) is unnecessary
// and breaks under webpack 5, which no longer polyfills core modules.
// jwt-decode throws on malformed input where jsonwebtoken returned null, so the
// null-on-failure contract the call sites rely on is preserved here.
const decode = (token) => {
  try {
    return jwtDecode(token);
  } catch (e) {
    return null;
  }
};

export default { decode };
